var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 105,
    viewBox: "0 0 98 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M76.0042 3.17215H71.2296C71.2296 1.42057 69.7993 0 68.034 0H12.4529C10.6882 0 9.25732 1.42016 9.25732 3.17215V87.4793C9.25732 89.2313 10.6882 90.6514 12.4529 90.6514C73.0398 90.6514 68.3176 90.8364 69.3611 90.3623C70.1698 89.9948 70.7966 89.303 71.0734 88.4546H76.004C76.0042 87.8457 76.0042 4.36098 76.0042 3.17215Z",
    fill: "#60B7FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.6772 0H68.0342C69.7991 0 71.2298 1.42016 71.2298 3.17215V87.4793C71.2298 89.2312 69.7991 90.6514 68.0342 90.6514H74.6772C76.4422 90.6514 77.8729 89.2312 77.8729 87.4793V3.17215C77.8729 1.42016 76.4422 0 74.6772 0Z",
    fill: "#26A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M77.873 21.7307L63.1128 7.07886H18.6755C16.236 7.07886 14.2583 9.04207 14.2583 11.4636V89.8637C14.2583 90.1332 14.2864 90.3957 14.3333 90.6516H74.6774C76.4423 90.6516 77.873 89.2314 77.873 87.4795V21.7307Z",
    fill: "#26A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M83.1073 22.5473L75.6176 17.9051L69.1514 7.07886H24.7141C22.2746 7.07886 20.2969 9.04207 20.2969 11.4636V89.8637C20.2969 92.2852 22.2746 94.2485 24.7141 94.2485H83.0216C83.0505 94.2485 83.0786 94.2448 83.1073 94.2441V22.5473Z",
    fill: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M87.4385 25.2321L80.7956 21.1147V89.864C80.7956 92.2856 78.8179 94.2488 76.3784 94.2488H83.0215C85.4609 94.2488 87.4387 92.2856 87.4387 89.864V25.2321H87.4385Z",
    fill: "#D8ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M73.5681 25.2319H87.4382L69.1509 7.07886V20.8472C69.1509 23.2687 71.1286 25.2319 73.5681 25.2319Z",
    fill: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M76.8374 35.168H30.8981C30.0155 35.168 29.3003 34.4578 29.3003 33.5819C29.3003 32.706 30.0155 31.9958 30.8981 31.9958H76.8374C77.7199 31.9958 78.4352 32.706 78.4352 33.5819C78.4352 34.4578 77.7199 35.168 76.8374 35.168Z",
    fill: "#82AEE3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M76.8374 45.6619H30.8981C30.0155 45.6619 29.3003 44.9517 29.3003 44.0758C29.3003 43.1999 30.0155 42.4897 30.8981 42.4897H76.8374C77.7199 42.4897 78.4352 43.1999 78.4352 44.0758C78.4352 44.9517 77.7199 45.6619 76.8374 45.6619Z",
    fill: "#82AEE3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M94.2494 52.4998H90.7865C90.045 51.2273 88.6592 50.3739 87.0965 50.3739C84.9047 50.3739 36.5388 50.3739 33.4554 50.3739L27.8463 41.1616H24.4462C23.8489 40.369 22.9054 39.8889 21.8885 39.8889H3.19561C1.43067 39.8889 0 41.3093 0 43.0611V100.77C0 103.106 1.9077 105 4.26081 105H87.0965C87.8001 105 88.5156 104.819 89.1484 104.471H89.1566C89.6936 104.176 90.158 103.768 90.5212 103.281H94.2492L94.2494 52.4998Z",
    fill: "#FDB441"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M24.7196 41.5904L29.3496 50.3739H35.9926L31.3626 41.5904C30.8112 40.5443 29.7204 39.8889 28.5312 39.8889H21.8882C23.0773 39.8889 24.1682 40.5443 24.7196 41.5904Z",
    fill: "#FEA613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M93.7395 50.3743H87.0967C89.45 50.3743 91.3575 52.268 91.3575 54.6038V100.77C91.3575 103.106 89.4498 105 87.0967 105H93.7395C96.0929 105 98.0003 103.106 98.0003 100.77V54.604C98.0003 52.268 96.0926 50.3743 93.7395 50.3743Z",
    fill: "#FEA613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDocumentIcon);
export default __webpack_public_path__ + "static/media/otherDocumentIcon.8f4fbfaa31eff796cf33f6beba149306.svg";
export { ForwardRef as ReactComponent };